import { Box, BoxProps } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { WfHeading } from "src/components/base/wf-heading";
import { CommentsArea, ICommentsAreaProps } from "src/components/common/comments-area/comments-area";
import { useNavHeight } from "src/components/layout/hooks/use-nav-height";
import { useRouterCaller } from "src/utils/router/use-router-caller";

interface ICommentsSection extends ICommentsAreaProps, BoxProps {
    isCurrentUserQualifiedCommenter: boolean;
}

export const CommentsSection = ({ entityId, user, isCurrentUserQualifiedCommenter, ...boxProps }: ICommentsSection) => {
    const { t } = useTranslation("news");
    const { NAV_HEIGHT_VARIATION } = useNavHeight();
    const { isCallerContentApp } = useRouterCaller();

    return (
        <Box scrollMarginTop={isCallerContentApp ? 0 : NAV_HEIGHT_VARIATION.map(m => m + 1)} as="section" {...boxProps}>
            <WfHeading as="h2" fontSize="2xl" mb="2">
                {t("headline.comments")}
            </WfHeading>
            <CommentsArea
                mb={[3, 3, 5]}
                entityId={entityId}
                user={user}
                isCurrentUserQualifiedCommenter={isCurrentUserQualifiedCommenter}
            ></CommentsArea>
        </Box>
    );
};
